import React from 'react';

const HeaderRemark = (props) => {
    return (
        <div className='esim-header-remark-wrapper'>
            <div className='esim-header-remark'>
                <span> {props.headerRemark} </span>
            </div>
        </div>
    );
};

export default HeaderRemark;